<template>
    <Component :is="sliceVariationComponent" v-bind="props" />
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {getSliceComponentProps} from '@prismicio/vue';
    import type {ReinsuranceSlice} from '@prismicio-types';
    import ReinsuranceDefault from './variations/ReinsuranceDefault.vue';
    import {getSliceVariationComponent} from '../../utils/sliceVariations';

    const props = defineProps(getSliceComponentProps<ReinsuranceSlice>());

    const variationComponents = {
        default: ReinsuranceDefault,
    };

    const sliceVariationComponent = computed(() => getSliceVariationComponent(props.slice, variationComponents));
</script>
